/**
 * Route path constants
 */

export const DEFAULT_PROTECTED_ROUTE_PATH = "/cases";

export const SUBSCRIPTION_PATH = "/subscription";

export const BAA_PATH = "/baa";

export const PROFILE_PATH = "/profile";
